"use client";

import { SiteTemplatePageSectionTypeListDefaultListItemSettingModel } from "@/Apis/ClinicApi";
import { ListSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeOneListGenerated, {
  HomeOneListGeneratedProps,
} from "../Sections/_generated/HomeOneList.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

function getListItems(
  props: ListSectionProps,
): SiteTemplatePageSectionTypeListDefaultListItemSettingModel[] {
  return props.lists.Default ?? [];
}

const GeneratedListSection: FC<ListSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeOneListGeneratedProps>("HomeOneList");
  const configuredItems = getListItems(props);

  const listDivs =
    configuredItems.length > 0
      ? configuredItems.map((item, index) => {
          const baseItem =
            defaults.listDivs[index % defaults.listDivs.length] ??
            defaults.listDivs[0];

          return {
            ...baseItem,
            key: item.Id,
            link0Text: item.Title ?? baseItem?.link0Text ?? "",
            href: item.Link ?? baseItem?.href ?? "#",
            src: item.Image?.Url ?? baseItem?.src ?? "",
            alt: item.Image?.AltText ?? baseItem?.alt ?? "img",
          };
        })
      : defaults.listDivs;

  return <HomeOneListGenerated {...defaults} listDivs={listDivs} />;
};

export default GeneratedListSection;
